
export const SET_MSG = 'AUTH_MSG';
export const SET_EDITAR = 'ACIDENTETRABALHOR_EDITAR';
export const SET_LISTA = 'ACIDENTETRABALHOR_LISTA';
export const SET_LISTAEVENTO = 'ACIDENTETRABALHOR_LISTAEVENTO';
